export const ReplaceSepcialChars = (str) => {
  return str
    .replace(/â€™/g, "’")
    .replace(/â€œ/g, "“")
    .replace(/â€/g, "”")
    .replace("\uFFFD", "");
};
